import { FormApi } from 'final-form';
import React from 'react';
import { useSelector } from 'react-redux';
import { Url } from 'src/api';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Abstract from 'src/models/Abstract';
import { SelectItem } from 'src/models/common/SelectItem';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import { IRootState } from 'src/reducers';
import useFetch from 'use-http';

interface IEastTexasSurveyPanelProps {
    counties: SelectItem[];
    formApi: FormApi;
}

const EastTexasSurveyPanel = (props: IEastTexasSurveyPanelProps) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const dialogContext = React.useContext<dialogCreators>(DialogContext);
    const [abstracts, setAbstracts] = React.useState<Array<Abstract>>([]);
    const [loading, setLoading] = React.useState<boolean>(undefined);
    const { get, response } = useFetch();

    const getAbstracts = async (formAbstractIds: number[]) => {
        setLoading(true);

        if (formAbstractIds?.length > 0) {
            setAbstracts(
                await Promise.all(
                    formAbstractIds.map(async (abstractId) => {
                        const result = await get(`${Url.project.getAbstractById(appContext, abstractId)}`);

                        if (response.ok) {
                            if (result.id && result.id !== 0) {
                                const responseAbstract = new Abstract();
                                responseAbstract.id = result.id;
                                responseAbstract.name = result.name;
                                responseAbstract.abstractNumber = result.abstractNumber;
                                responseAbstract.section = result.section;
                                responseAbstract.legal = result.legal;
                                responseAbstract.acres = result.acres;

                                return responseAbstract;
                            }
                        }
                        return undefined;
                    })
                )
            );
        }

        // if (parseInt(wtCounty.countyId, 10) === countyId && parseInt(wtCounty.abstractNumber, 10) === abstractNumber) {
        //     formApi.change(`westTexasCounties[${index}].abstractId`, result.id);
        //     formApi.change(`westTexasCounties[${index}].name`, result.name);
        //     formApi.change(`westTexasCounties[${index}].acres`, result.acres);
        //     formApi.change(`westTexasCounties[${index}].legal`, result.legal);
        //     formApi.change(`westTexasCounties[${index}].section`, result.section);
        // }
        setLoading(false);
    };

    React.useEffect(() => {
        const abstractsIds = abstracts.map((a) => a.id);
        const propAbstractIds = (props.formApi.getState()?.values as { eastTexasAbstractIds: number[] })?.eastTexasAbstractIds;

        if (abstractsIds.sort().join(',') !== propAbstractIds?.sort().join(',')) {
            getAbstracts(propAbstractIds);
        }
    }, []);

    const onAbstractSelected = (selectedAbstract: Abstract) => {
        if (abstracts.filter((a) => a.id === selectedAbstract.id).length === 0) {
            props.formApi.change(`eastTexasAbstractIds[${abstracts.length}]`, selectedAbstract.id);
            props.formApi.change('dirtyEastTexasAbstracts', Math.random().toString(36).substring(2, 7));
            setAbstracts((a) => [...a, selectedAbstract]);
        }
    };

    const openDialog = () => {
        dialogContext.tract.addEastTexasAbstract(props.counties, onAbstractSelected);
    };

    const clearAbstract = (index: number) => {
        const propAbstractIds = (props.formApi.getState()?.values as { eastTexasAbstractIds: number[] })?.eastTexasAbstractIds;
        const ids = propAbstractIds?.filter((id, i) => i !== index);
        setAbstracts(abstracts?.filter((_, i) => i !== index));
        props.formApi.change('eastTexasAbstractIds', ids);
        props.formApi.change('dirtyEastTexasAbstracts', Math.random().toString(36).substring(2, 7));
    };

    const abstractPanel = () => {
        if (loading) {
            return <div>loading...</div>;
        }

        if (abstracts.length === 0) {
            return (
                <div style={{ fontWeight: 'bold', padding: '1rem' }}>
                    No Abstract Selected -{' '}
                    <span onClick={openDialog} style={{ color: '#6393C1', cursor: 'pointer' }}>
                        Select Abstract
                    </span>
                </div>
            );
        }

        const mainStyle: React.CSSProperties = {
            backgroundColor: 'transparent',
            position: 'relative',
            padding: '1rem',
        };

        const altStyle: React.CSSProperties = {
            backgroundColor: '#f5f5f5',
            position: 'relative',
            padding: '1rem',
        };

        return (
            <>
                {abstracts?.map((a, index) => (
                    <div key={index} style={index % 2 === 0 ? mainStyle : altStyle}>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Number:</span> {a.abstractNumber}
                            <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Name:</span> {a.name}
                            <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Acres:</span> {a.acres}
                        </div>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Legal:</span> {a.legal || '[No Legal]'}
                            <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Section:</span> {a.section || '[No Section]'}
                        </div>
                        <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
                            <Button intent="primary" text="Remove Abstract" onClick={() => clearAbstract(index)} />
                        </div>
                    </div>
                ))}
            </>
        );
    };

    return (
        <>
            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                <legend className="legend">Texas Abstract</legend>
            </fieldset>
            {/* <Button onClick={openDialog} text="Open" />
            <Button onClick={clearAbstract} text="ClearAbstract" /> */}
            {abstracts && abstracts.length > 0 && (
                <div style={{ border: '1px solid #ccc', background: 'white', padding: '1rem', marginBottom: '1rem' }}>
                    <div style={{ fontWeight: 'bold' }}>
                        <span onClick={openDialog} style={{ color: '#6393C1', cursor: 'pointer' }}>
                            Add Another Abstract
                        </span>
                    </div>
                </div>
            )}
            <div style={{ border: '1px solid #ccc', background: 'white', padding: 0, marginBottom: '1rem' }}>{abstractPanel()}</div>
        </>
    );
};

EastTexasSurveyPanel.displayName = 'EastTexasSurveyPanel';

export default EastTexasSurveyPanel;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/panels/EastTexasSurveyPanel.tsx